import React, { useContext, useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { BasicContext } from "../../../App";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import ClassTemplate from "../../../components/classes/ClassTemplate";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faCalendar, faClock } from "@fortawesome/free-regular-svg-icons";
import ClassTemplatesDropdown from "../../../components/dropdowns/ClassTemplatesDropdown";
import { FormField, Radio } from "semantic-ui-react";
import ConfirmModal from "../../../components/modals/ConfirmModal";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
import moment from "moment";
registerLocale("pl", pl);

const CreatingClass = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts } = useContext(BasicContext);
    const [loading, setLoading] = useState(true);
    const [loadingClassTemplate, setLoadingClassTemplate] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const [option, setOption] = useState(null);
    const [formChanged, setFormChanged] = useState(false);
    const [classesTemplatesOptions, setClassesTemplatesOptions] = useState(null);
    const [classT, setClassT] = useState({
        class_template_id: null,
        class_type_code: null,
        class_level_code: null,
        class_stat_code: null,
        location_id: null,
        instructor_user_id: null,
        instructor_label: "",
        class_slots: "",
        class_name: "",
        class_descr: "",
        early_cancel_available: true,
        class_signup_start_time: null,
        signUpClose: null,
    });
    const [startDate, setStartDate] = useState({ date: null, startHour: null, endHour: null });
    const [classPeriodicity, setClassPeriodicity] = useState(null);
    const [bookingWindowTime, setBookingWindowTime] = useState("default");
    const [weekBtns, setWeekBtns] = useState([
        { selected: false, value: 1, name: t("Mo.") },
        { selected: false, value: 2, name: t("Tu.") },
        { selected: false, value: 3, name: t("We.") },
        { selected: false, value: 4, name: t("Th.") },
        { selected: false, value: 5, name: t("Fr.") },
        { selected: false, value: 6, name: t("Sa.") },
        { selected: false, value: 0, name: t("Su.") },
    ]);
    const [periodicityEndsWith, setPeriodicityEndsWith] = useState("");
    const [showTheSameClassWarningModal, setShowTheSameClassWarningModal] = useState(false);
    const [bookingWindowDays, setBookingWindowDays] = useState(null);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (classT.class_name.length === 0 || !classT.class_name.replace(/\s+/, "")) {
            $("#className").addClass("is-invalid");
            errors.push(t("error.noClassName"));
        } else if (classT.class_name.length > 50) {
            $("#className").addClass("is-invalid");
            errors.push(t("error.classNameTooLong"));
        } else $("#className").removeClass("is-invalid");

        if (classT.instructor_label) {
            if (!classT.class_name.replace(/\s+/, "")) {
                $("#classInstructorLabel").addClass("is-invalid");
                errors.push(t("error.invalidClassGuest"));
            } else if (classT.class_name.length > 50) {
                $("#classInstructorLabel").addClass("is-invalid");
                errors.push(t("error.classGuestTooLong"));
            } else $("#classInstructorLabel").removeClass("is-invalid");
        }

        if (classT.class_slots.length === 0) {
            $("#classSlots").addClass("is-invalid");
            errors.push(t("error.noClassSlots"));
        } else if (classT.class_slots.length > 11 || classT.class_slots <= 0 || classT.class_slots === "0" || !/^[1-9][0-9]*$/.test(classT.class_slots)) {
            $("#classSlots").addClass("is-invalid");
            errors.push(t("error.invalidClassSlots"));
        } else $("#classSlots").removeClass("is-invalid");
        if (!classT.class_duration) {
            $("#classDuration").addClass("is-invalid");
            errors.push(t("error.noClassDuration"));
        } else if (classT.class_duration.length === 0) {
            $("#classDuration").addClass("is-invalid");
            errors.push(t("error.noClassDuration"));
        } else if (classT.class_duration.length > 11 || classT.class_duration <= 0 || classT.class_duration === "0" || !/^[1-9][0-9]*$/.test(classT.class_duration)) {
            $("#classDuration").addClass("is-invalid");
            errors.push(t("error.invalidClassDuration"));
        } else $("#classDuration").removeClass("is-invalid");

        if (!classT.instructor_user_id) {
            $("#classInstructorDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedInstructor"));
        } else $("#classInstructorDropdown").removeClass("is-invalid");
        if (!classT.class_level_code) {
            $("#classLevelsDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedClassLevel"));
        } else $("#classLevelsDropdown").removeClass("is-invalid");
        if (!classT.class_type_code) {
            $("#classTypesDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedClassType"));
        } else $("#classTypesDropdown").removeClass("is-invalid");
        if (!classT.location_id) {
            $("#classLocationsDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedLocation"));
        } else $("#classLocationsDropdown").removeClass("is-invalid");
        if (classT.class_descr.length === 0 || !classT.class_descr.replace(/\s+/, "")) {
            $("#classDescription").addClass("is-invalid");
            errors.push(t("error.noClassDescription"));
        } else if (classT.class_descr.length > 255) {
            $("#classDescription").addClass("is-invalid");
            errors.push(t("error.classDescriptionTooLong"));
        } else $("#classDescription").removeClass("is-invalid");

        if (!startDate.date) {
            $("#classStartDate").addClass("is-invalid");
            errors.push(t("error.noClassDate"));
        } else if (!/^\d{4}-\d{2}-\d{2}$/.test(moment(startDate.date).format("YYYY-MM-DD"))) {
            $("#classStartDate").addClass("is-invalid");
            errors.push(t("error.invalidClassDate"));
        } else $("#classStartDate").removeClass("is-invalid");

        if (!startDate.startHour) {
            $("#classStartDateStartHour").addClass("is-invalid");
            errors.push(t("error.noClassStartHour"));
        } else if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(moment(startDate.startHour).format("HH:mm"))) {
            $("#classStartDateStartHour").addClass("is-invalid");
            errors.push(t("error.invalidClassStartHour"));
        } else $("#classStartDateStartHour").removeClass("is-invalid");

        if (!startDate.endHour) {
            $("#classStartDateEndHour").addClass("is-invalid");
            errors.push(t("error.noClassEndHour"));
        } else if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(moment(startDate.endHour).format("HH:mm"))) {
            $("#classStartDateEndHour").addClass("is-invalid");
            errors.push(t("error.invalidClassEndHour"));
        } else $("#classStartDateEndHour").removeClass("is-invalid");

        if (startDate.startHour && startDate.endHour && moment(startDate.endHour).format("HH:mm") < moment(startDate.startHour).format("HH:mm")) {
            $("#classStartDateStartHour").addClass("is-invalid");
            $("#classStartDateEndHour").addClass("is-invalid");
            errors.push(t("error.endHourCannotBeEarlierThanStartHour"));
        } else {
            $("#classStartDateStartHour").removeClass("is-invalid");
            $("#classStartDateEndHour").removeClass("is-invalid");
        }

        if (!classPeriodicity) {
            errors.push(t("error.noCheckedClassPeriodicity"));
        } else if (classPeriodicity === "repeats") {
            if (!periodicityEndsWith || periodicityEndsWith.length === 0) {
                $("#periodicityEndsWith").addClass("is-invalid");
                errors.push(t("error.noPeriodicityEndsWith"));
            } else if (periodicityEndsWith < 1 || periodicityEndsWith > 30) {
                $("#periodicityEndsWith").addClass("is-invalid");
                errors.push(t("error.invalidPeriodicityEndsWith"));
            } else $("#periodicityEndsWith").removeClass("is-invalid");
        }

        if (bookingWindowTime === "chooseDate" && !classT.class_signup_start_time) {
            $("#classSignUpStartDate").addClass("is-invalid");
            errors.push(t("error.noClassSignUpStartDate"));
        } else if (bookingWindowTime === "chooseDate" && !/^\d{4}-\d{2}-\d{2}$/.test(moment(classT.class_signup_start_time).format("YYYY-MM-DD"))) {
            $("#classSignUpStartDate").addClass("is-invalid");
            errors.push(t("error.invalidClassSignUpStartDate"));
        } else $("#classSignUpStartDate").removeClass("is-invalid");

        if (!classT.signUpClose || classT.signUpClose < 1 || classT.signUpClose.length > 11) {
            $("#classesSignupClose").addClass("is-invalid");
            errors.push(t("error.invalidClassesSignupCloseValue"));
        } else $("#classesSignupClose").removeClass("is-invalid");

        if (errors.length > 0) {
            setAlerts([
                {
                    variant: "danger",
                    message: (
                        <div>
                            <p>{t("appearedErrors")}:</p>
                            <p>
                                {errors.map((e, i) => (
                                    <span key={i}>
                                        {e}
                                        {i + 1 < errors.length ? " " : ""}
                                    </span>
                                ))}
                            </p>
                        </div>
                    ),
                },
            ]);
        } else {
            setAlerts([{ variant: "info", message: t("info.checkingConditions") }]);
            setBlockForm(true);
            checkTheSameClass();
        }
    };

    const checkTheSameClass = async () => {
        const res = await postMethod("/check-the-same-class", {
            classT: classT,
            classPeriodicity: classPeriodicity,
            weekBtns: weekBtns,
            periodicityEndsWith: periodicityEndsWith,
            startDate: startDate,
        });
        if (checkServerData(res)) {
            if (res.data.repeatingOne.length > 0) setShowTheSameClassWarningModal(res.data.repeatingOne);
            else if (res.data.moreThanOne.length > 0) setShowTheSameClassWarningModal(res.data.moreThanOne);
            else {
                setAlerts([{ variant: "info", message: t("info.creatingNewClass") }]);
                createClass();
            }
        }
    };

    useEffect(() => {
        if (showTheSameClassWarningModal) setAlerts([]);

        // eslint-disable-next-line
    }, [showTheSameClassWarningModal]);

    const createClass = async () => {
        const res = await postMethod("/create-class", {
            classT: classT,
            classPeriodicity: classPeriodicity,
            weekBtns: weekBtns,
            periodicityEndsWith: periodicityEndsWith,
            startDate: startDate,
            bookingWindowTime: bookingWindowTime,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "createdClass" }]);
            if (option === "fromScratch") changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } });
        }
        setBlockForm(false);
    };

    const getClassTemplates = async () => {
        const res = await postMethod("/get-classes-templates");
        if (checkServerData(res)) {
            const list = [],
                templateList = res.data.list;
            templateList.forEach((e, i) => {
                list.push({
                    key: i,
                    value: e.class_template_id,
                    text: e.class_name,
                });
            });
            setClassesTemplatesOptions(list);
        }
    };

    const autoResize = (textarea) => {
        textarea.style.height = "auto"; // Resetowanie wysokości
        textarea.style.height = `${textarea.scrollHeight}px`; // Ustawienie wysokości na podstawie zawartości
    };

    const getClassTemplateData = async (templateID) => {
        const res = await postMethod("/get-class-template-data", { templateID: templateID });
        if (checkServerData(res)) {
            const template = res.data.template;
            setClassT((prevClassT) => ({
                ...prevClassT,
                ...template,
            }));
        }
    };

    useEffect(() => {
        if (classT && loadingClassTemplate) {
            setTimeout(() => {
                setLoadingClassTemplate(false);
                const textarea = document.getElementById("classDescription");
                autoResize(textarea);
                textarea.addEventListener("input", function () {
                    autoResize(this);
                });
            }, 500);
        }
        // eslint-disable-next-line
    }, [classT]);

    useEffect(() => {
        if (classesTemplatesOptions) setLoading(false);
        // eslint-disable-next-line
    }, [classesTemplatesOptions]);

    const getGlobalSettings = async () => {
        const res = await postMethod("/get-global-settings");
        if (checkServerData(res)) {
            const settings = res.data.settings;
            setClassT({ ...classT, signUpClose: settings.filter((e) => e.setting_code === "SIGNUP_CLOSE")[0].setting_value_int });
            setBookingWindowDays(settings.filter((e) => e.setting_code === "BOOKING_WINDOW")[0].setting_value_int);
            getClassTemplates();
        }
    };

    useEffect(() => {
        getGlobalSettings();
        $(`#createSchedule`).css("min-height", `${window.innerHeight - $("#footerMain").outerHeight() - 61}px`);
        // eslint-disable-next-line
    }, []);

    return (
        <div id="createSchedule">
            <GoBackBtn />
            <Container fluid="lg">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t("classes.creatingNewClass")}</h1>
                    </Col>
                    {loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                {classesTemplatesOptions.length > 0 && (
                                    <>
                                        {!option && (
                                            <Row className="mb-4" id="createClassOptionBtns">
                                                <Col xs={12}>
                                                    <Form.Label>{t("classes.class")}</Form.Label>
                                                </Col>
                                                <Col xs={6} lg={4} xxl={3}>
                                                    <Button
                                                        variant="outline-primary"
                                                        className={option === "fromTemplate" ? "active w-100" : "w-100"}
                                                        onClick={() => setOption("fromTemplate")}
                                                    >
                                                        {t("classes.chooseFromTemplate")}
                                                    </Button>
                                                </Col>
                                                <Col xs={6} lg={4} xxl={3}>
                                                    <Button
                                                        variant="outline-secondary"
                                                        className={option === "fromScratch" ? "active w-100" : "w-100"}
                                                        onClick={() => setOption("fromScratch")}
                                                    >
                                                        {t("classes.createFromScratch")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}
                                {option === "fromTemplate" && classesTemplatesOptions.length > 0 && (
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <ClassTemplatesDropdown
                                                options={classesTemplatesOptions}
                                                onChange={(v) => {
                                                    setClassT({ ...classT, class_template_id: v });
                                                    setLoadingClassTemplate(true);
                                                    getClassTemplateData(v);
                                                }}
                                                disabled={blockForm}
                                            />
                                        </Col>
                                    </Row>
                                )}
                                <Row>
                                    {((option === "fromTemplate" && classT.class_template_id) || option === "fromScratch" || (!option && classesTemplatesOptions.length === 0)) && (
                                        <>
                                            {loadingClassTemplate ? (
                                                <Col xs={12} className="my-3 text-center">
                                                    <p className="h5">
                                                        {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                                    </p>
                                                </Col>
                                            ) : (
                                                <>
                                                    <Col xs={12}>
                                                        <ClassTemplate template={classT} blockForm={blockForm} setTemplate={setClassT} setFormChanged={setFormChanged} />
                                                    </Col>

                                                    <Col xs={12} lg={6} xl={4}>
                                                        <Form.Group>
                                                            <Form.Label>
                                                                {t("classes.classDate")} <span className="req">*</span>
                                                            </Form.Label>
                                                            <DatePicker
                                                                autoComplete="off"
                                                                selected={startDate.date}
                                                                onChange={(date) => {
                                                                    setStartDate({ ...startDate, date: date });
                                                                    $("#classStartDate").removeClass("is-invalid");
                                                                    setFormChanged(true);
                                                                }}
                                                                showIcon
                                                                locale="pl"
                                                                dateFormat="yyyy-MM-dd"
                                                                icon={<FontAwesomeIcon icon={faCalendar} />}
                                                                className="mb-3"
                                                                placeholderText={t("choose")}
                                                                id="classStartDate"
                                                                disabled={blockForm}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} lg={3} xl={3}>
                                                        <Form.Group>
                                                            <Form.Label>
                                                                {t("startHour")} <span className="req">*</span>
                                                            </Form.Label>
                                                            <DatePicker
                                                                autoComplete="off"
                                                                selected={startDate.startHour}
                                                                onChange={(date) => {
                                                                    const setEndDate = (start) => {
                                                                        const timeOnly = new Date(start);
                                                                        return classT.class_duration
                                                                            ? new Date(timeOnly.setMinutes(timeOnly.getMinutes() + parseInt(classT.class_duration)))
                                                                            : null;
                                                                    };
                                                                    const endTime = setEndDate(date);
                                                                    setStartDate({
                                                                        ...startDate,
                                                                        startHour: date,
                                                                        endHour: endTime,
                                                                    });
                                                                    $("#classStartDateStartHour").removeClass("is-invalid");
                                                                    setFormChanged(true);
                                                                }}
                                                                showIcon
                                                                locale="pl"
                                                                dateFormat="HH:mm"
                                                                icon={<FontAwesomeIcon icon={faClock} />}
                                                                className="mb-3"
                                                                placeholderText={t("choose")}
                                                                timeCaption={t("hour")}
                                                                showTimeSelect
                                                                showTimeSelectOnly
                                                                timeIntervals={5}
                                                                disabled={!startDate.date || blockForm}
                                                                id={"classStartDateStartHour"}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} lg={3} xl={3}>
                                                        <Form.Group>
                                                            <Form.Label>
                                                                {t("endHour")} <span className="req">*</span>
                                                            </Form.Label>
                                                            <DatePicker
                                                                autoComplete="off"
                                                                selected={startDate.endHour}
                                                                onChange={(date) => {
                                                                    setStartDate({ ...startDate, endHour: date });
                                                                    $("#classStartDateEndHour").removeClass("is-invalid");
                                                                    setFormChanged(true);
                                                                }}
                                                                showIcon
                                                                locale="pl"
                                                                dateFormat="HH:mm"
                                                                icon={<FontAwesomeIcon icon={faClock} />}
                                                                className="mb-3"
                                                                placeholderText={t("choose")}
                                                                timeCaption={t("hour")}
                                                                showTimeSelect
                                                                showTimeSelectOnly
                                                                timeIntervals={5}
                                                                disabled={!startDate.date || !startDate.startHour || blockForm}
                                                                id="classStartDateEndHour"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                {t("classes.periodicityOfClass")} <span className="req">*</span>
                                                            </Form.Label>

                                                            <FormField>
                                                                <Radio
                                                                    disabled={blockForm}
                                                                    label={t("classes.singleClass")}
                                                                    name="radioGroup"
                                                                    value={"single"}
                                                                    checked={classPeriodicity === "single"}
                                                                    onChange={() => {
                                                                        setClassPeriodicity("single");
                                                                        setFormChanged(true);
                                                                    }}
                                                                />
                                                            </FormField>
                                                            <FormField>
                                                                <Radio
                                                                    disabled={blockForm}
                                                                    label={t("classes.classRepeatsItself")}
                                                                    name="radioGroup"
                                                                    value="repeats"
                                                                    checked={classPeriodicity === "repeats"}
                                                                    onChange={() => setClassPeriodicity("repeats")}
                                                                />
                                                            </FormField>
                                                        </Form.Group>
                                                    </Col>
                                                    {classPeriodicity === "repeats" && (
                                                        <>
                                                            <Col xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        {t("classes.selectWeekDays")} <span className="req">*</span>
                                                                    </Form.Label>
                                                                    <ButtonGroup aria-label="weeksBtnGroup" id="weeksBtnGroup" className="mb-3 d-block">
                                                                        {weekBtns.map((e, index) => (
                                                                            <Button
                                                                                disabled={blockForm}
                                                                                key={index}
                                                                                size="sm"
                                                                                variant="outline-primary"
                                                                                className="me-2" // Margines dla oddzielenia przycisków
                                                                                active={e.selected}
                                                                                onClick={() => {
                                                                                    const list = [...weekBtns];
                                                                                    list.forEach((el) => {
                                                                                        if (el.name === e.name) el.selected = !el.selected;
                                                                                    });
                                                                                    setWeekBtns(list);
                                                                                }}
                                                                            >
                                                                                {e.name}
                                                                            </Button>
                                                                        ))}
                                                                    </ButtonGroup>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12}>
                                                                <Form.Group className="mb-3" controlId="periodicityEndsWith">
                                                                    <Form.Label className="d-block">
                                                                        {t("classes.periodicityEndsWith")}: <span className="req">*</span>
                                                                    </Form.Label>

                                                                    <Form.Control
                                                                        disabled={blockForm}
                                                                        value={periodicityEndsWith}
                                                                        type="number"
                                                                        onChange={(e) => {
                                                                            setPeriodicityEndsWith(e.target.value);
                                                                            setFormChanged(true);
                                                                            $("#periodicityEndsWith").removeClass("is-disabled");
                                                                        }}
                                                                        className="d-inline-block"
                                                                        style={{ width: "70px" }}
                                                                        min={1}
                                                                        max={30}
                                                                    />
                                                                    <span className="ps-2">{t("occurences")}</span>
                                                                    <p className="mb-3 mt-1 text-small">{t("classes.periodicityEndsWithHelper")}</p>
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                    )}
                                                    <Col xs={12} lg={5}>
                                                        <Form.Group controlId="radioGroupbookingWindow" className="mb-3">
                                                            <Form.Label>
                                                                {t(`classes.bookingWindow`)} <span className="req">*</span>
                                                            </Form.Label>
                                                            <FormField>
                                                                <Radio
                                                                    disabled={blockForm}
                                                                    label={`${bookingWindowDays} ${t("days")}`}
                                                                    name="radioGroupbookingWindow"
                                                                    value="default"
                                                                    checked={bookingWindowTime === "default"}
                                                                    onChange={() => {
                                                                        setBookingWindowTime("default");
                                                                        setClassT({ ...classT, class_signup_start_time: null });
                                                                        setFormChanged(true);
                                                                    }}
                                                                />
                                                            </FormField>
                                                            <FormField className="mb-2">
                                                                <Radio
                                                                    disabled={blockForm}
                                                                    label={t("chooseDate")}
                                                                    name="radioGroupbookingWindow"
                                                                    value="chooseDate"
                                                                    checked={bookingWindowTime === "chooseDate"}
                                                                    onChange={() => {
                                                                        setBookingWindowTime("chooseDate");
                                                                        setFormChanged(true);
                                                                    }}
                                                                />
                                                            </FormField>
                                                            <DatePicker
                                                                autoComplete="off"
                                                                selected={classT.class_signup_start_time}
                                                                onChange={(date) => {
                                                                    setClassT({ ...classT, class_signup_start_time: date });
                                                                    $("#classSignUpStartDate").removeClass("is-invalid");
                                                                    setFormChanged(true);
                                                                }}
                                                                showIcon
                                                                locale="pl"
                                                                dateFormat="yyyy-MM-dd"
                                                                icon={<FontAwesomeIcon icon={faCalendar} />}
                                                                className="mb-3"
                                                                placeholderText={t("choose")}
                                                                id="classSignUpStartDate"
                                                                disabled={blockForm || bookingWindowTime === "default"}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} lg={5}>
                                                        <Form.Group controlId="classesSignupClose" className="mb-3">
                                                            <Form.Label>
                                                                {t(`classes.signupClose`)}:<span className="req">*</span>
                                                            </Form.Label>
                                                            <p className="mb-1 text-small">{t("optionFromGlobalSettings")}</p>
                                                            <Form.Control
                                                                type="number"
                                                                value={classT.signUpClose}
                                                                onChange={(e) => {
                                                                    setClassT({ ...classT, signUpClose: e.target.value });
                                                                    setFormChanged(true);
                                                                    $("classesSignupClose").removeClass("is-invalid");
                                                                }}
                                                                disabled={blockForm}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                            )}
                                        </>
                                    )}
                                </Row>
                                <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 1 }}>
                                    <Col xs={12} className="my-4">
                                        <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                                            {t("create")}
                                        </Button>

                                        <Button
                                            variant="outline-secondary"
                                            className="float-end"
                                            onClick={() => changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } })}
                                        >
                                            {t("cancel")}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>

            {showTheSameClassWarningModal && (
                <ConfirmModal
                    show={true}
                    onClose={() => {
                        setAlerts([]);
                        setBlockForm(false);
                        setShowTheSameClassWarningModal(false);
                    }}
                    onProceed={() => {
                        setShowTheSameClassWarningModal(false);
                        setAlerts([{ variant: "info", message: t("info.creatingNewClass") }]);
                        createClass();
                    }}
                    title={t("theSameClassWarningModal.title")}
                    text={
                        <div>
                            <p>{t("theSameClassWarningModal.txt1")}</p>
                            <p>
                                {showTheSameClassWarningModal.map((e, i) => (
                                    <span key={i} className="text-bold">
                                        {e}
                                        {i + 1 < showTheSameClassWarningModal.length ? ", " : "."}
                                    </span>
                                ))}
                            </p>
                            <p>{t("theSameClassWarningModal.txt2")}</p>
                        </div>
                    }
                    proceedTxt={t("theSameClassWarningModal.proceedTxt")}
                    cancelTxt={t("theSameClassWarningModal.cancelTxt")}
                />
            )}
        </div>
    );
};

export default CreatingClass;
